import { Flex, Text, Box, Badge, Spinner, Button } from "@chakra-ui/react";
import { FC } from "react";
import { Card } from "../..";
import { IGponDevice } from "../../../../hooks/useGponList";
import { useGponDetails } from "../../../../hooks/useGponDetails";
import { formatClock, timestampToDateString } from "../../../utils";
import { useNavigate } from "react-router-dom";

interface GponDeviceProps {
  id: string;
}


const GponDevice: FC<GponDeviceProps> = ({ id }) => {
  const { data, isLoading } = useGponDetails(id);
  const navigate = useNavigate()

  if (isLoading || !data) {
    return (
      <Box
        bg="gray.100"
        borderRadius="md"
        p={4}
        mb={4}
        mt={4}
        width="100%"
        minW="220px"
        minH="200px"
      >
        <Spinner size="lg" />
      </Box>
    );
  }

  const {
    modelName,
    // profileData,
    serialNumber,
    receiverPower,
    status,
    historyDate,
    protocol,
    wifiSsid,
    wifiPassword,
  } = data;



  const getPowerColor = (value: number): string => {
    if (value === 0) return "gray";
    if (value > -25) return "lime";
    if (value >= -28) return "orange";
    return "red";
  };

  return (
    <Button
      bg="gray.100"
      borderRadius="md"
      p={4}
      mb={4}
      mt={4}
      width="100%"
      minW="220px"
      minH="200px"
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      overflow={"hidden"}
      onClick={() => {
        navigate(`gpon/${id}`);
      }}
    >
      <Text fontWeight="bold" fontSize="md">
        {/* {profileData?.name || "Brak nazwy"} */}
        {modelName || "Brak nazwy"}
      </Text>
      <Text fontSize="sm" color="gray.700" mb={3}>
        S/N: {serialNumber || "Brak numeru"}
      </Text>
      {/* 
      {
        (protocol !== 'bridge' && wifiSsid && wifiPassword) ? (
          <>
            <Text fontSize="sm" color="gray.700" >
              SSID: {wifiSsid || 'Brak'}
            </Text>
            <Text fontSize="sm" color="gray.700" mb={3}>
              Hasło: {wifiPassword || 'Brak'}
            </Text>
          </>
        ) : null
      } */}

      <Flex width="100%" justify="center">
        <Badge
          fontSize="md"
          px={5}
          py={2}
          borderRadius="xl"
          // bg="lime"
          color="white"
          bg={getPowerColor(Number(receiverPower))}
          textTransform="none"
        >
          {receiverPower ? receiverPower + ' dBm' : 'Brak mocy'}
        </Badge>
      </Flex>

      <Box mt={4}>
        <Text fontSize="md">status: {status || "Brak"}</Text>
      </Box>

      <Text fontSize="xs" textAlign="left" color="gray.500" mt={2}>
        {historyDate
          ? `Odczytano ${timestampToDateString(Number(historyDate) * 1000) + ' ' + formatClock(Number(historyDate) * 1000)}`
          : "Brak daty"}
      </Text>
    </Button>
  );
};



export interface IGponDevicesCard {
  gponDevices: IGponDevice[];
}


export const GponDevicesCard: FC<IGponDevicesCard> = ({ gponDevices }) => {

  return (
    <Card title="Światłowodowe" titleStyle={{ marginLeft: '5px' }} >
      <Flex overflowX="auto" gap={4} px={2}>
        {gponDevices.length
          ? gponDevices.map(({ id }) => (
            <Box key={id} minW="240px" flex="0 0 auto" m={"0px 5px"}>
              <GponDevice id={id.toString()} />
            </Box>
          ))
          : null}
      </Flex>

    </Card>
  );
};
